import { List, ListItemButton, ListItemText, Paper } from "@mui/material";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import useTimeOffList from "../../hooks/useTimeOffList";
import Timeoff from "../../models/Timeoff";
import { TimeOffStatus } from "../../types/TimeOffType";
import OpsStringUtils from "../../utils/OpsStringUtils";
import TimeOffUtils from "../../utils/TimeOffUtils";
import TimeOffStatusDialog from "../TimeOffStatusDialog";
import OpsPanel from "../OpsPanel";
import check from "../../img/icons/fact_check.svg";

interface Props {
  /**
   * The list of timeoffs
   */
  rows: Timeoff[];

  /**
   * The function to get the data
   */
  fetchData: () => Promise<void>;
}

export default function PendingTimeoffTile({ rows, fetchData }: Props) {
  const history = useHistory();

  const [timeoff, setTimeoff] = useState<Timeoff | undefined>();
  const { timeoffState, handleMissingDocumentationRequested, handleOnChangeTimeOffStatus } = useTimeOffList();

  const onHandleTimeoffStatus = async (data: Timeoff, status: TimeOffStatus) => {
    await handleOnChangeTimeOffStatus(data, status);
    fetchData();
    setTimeoff(undefined);
  };

  return rows.length > 0 ? (
    <>
      <OpsPanel title="Timeoff Approval" actionsRequired={false} icon={check}>
        <Paper elevation={0} style={{ minHeight: "15.5em", maxHeight: "15.5em", overflow: "auto" }}>
          <List disablePadding>
            {rows.map((timeoff, index) => (
              <ListItemButton key={timeoff.externalId ?? `pending-timeoff-${index}`} alignItems="flex-start" disableGutters dense>
                <ListItemText
                  primary={timeoff.requesterProjectName!.concat(" - ", timeoff.requester.firstName, " ", timeoff.requester.lastName)}
                  secondary={TimeOffUtils.getTimeoffDetails(timeoff) + " - " + OpsStringUtils.capitalize(timeoff.status)}
                  onClick={() => setTimeoff(timeoff)}
                  primaryTypographyProps={{ fontWeight: "bold" }}
                />
              </ListItemButton>
            ))}
          </List>
        </Paper>
      </OpsPanel>

      {timeoff && (
        <TimeOffStatusDialog
          title={"Timeoff request - " + timeoff.type + " - " + timeoff.totalDays + (timeoff.totalDays > 1 ? " days" : " day")}
          message={TimeOffUtils.timeoffStatusMessage(timeoff)}
          timeoff={timeoff}
          onClose={() => setTimeoff(undefined)}
          handleApproval={async (data, status) => onHandleTimeoffStatus(timeoff, status)}
          handleExtraFunction={() => {
            onHandleTimeoffStatus(timeoff, TimeOffStatus.ADD_DOCUMENTATION);
          }}
          extraButton
          missingDocumentation={handleMissingDocumentationRequested(timeoff)}
        />
      )}
    </>
  ) : null;
}
